module.exports = __webpack_public_path__ + "static/media/20ECE18.0b06ad32.jpg";